import { type IPikHistoryItem } from '../IPikHistoryItem';

/**
 * @description Класс для создания элемента истории ПИК
 * @param chipsOption - Опция чипа
 * @param title - Заголовок элемента
 * @param description - Описание элемента
 * @example
 * const pikHistoryItem = new PikHistoryItem(new ChipsOption('2021'), 'Заголовок', 'Описание');
 * console.log(pikHistoryItem.chipsOption.label); // '2021'
 * console.log(pikHistoryItem.title); // 'Заголовок'
 * console.log(pikHistoryItem.description); // 'Описание'
 */
export class PikHistoryItem implements IPikHistoryItem {
  public readonly chipsOption: IPikHistoryItem['chipsOption'];
  public readonly title: string;
  public readonly description: string;

  public constructor(chipsOption: IPikHistoryItem['chipsOption'], title: string, description: string) {
    this.chipsOption = chipsOption;
    this.title = title;
    this.description = description;
  }
}
